import { render, staticRenderFns } from "./ShiftsSurplusMark.vue?vue&type=template&id=477a3c6b&lang=pug"
import script from "./ShiftsSurplusMark.vue?vue&type=script&lang=js"
export * from "./ShiftsSurplusMark.vue?vue&type=script&lang=js"
import style0 from "./ShiftsSurplusMark.vue?vue&type=style&index=0&id=477a3c6b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports